import { render } from "./SavingsEnrollmentForMinors.vue?vue&type=template&id=72a74396&scoped=true"
import script from "./SavingsEnrollmentForMinors.vue?vue&type=script&lang=js"
export * from "./SavingsEnrollmentForMinors.vue?vue&type=script&lang=js"

import "./SavingsEnrollmentForMinors.vue?vue&type=style&index=0&id=72a74396&lang=css"
import "./SavingsEnrollmentForMinors.vue?vue&type=style&index=1&id=72a74396&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a74396"]])

export default __exports__